import { gql, useLazyQuery } from "@apollo/client";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import IsoToDateTime, { IsoToDateWithoutTime } from "../../../CommonFunction/IsoDateTime";
import { getFields } from "../../../Utils/AllPagesQuriesAndMutations";
import { LoadTable, Loading } from "../../Components";
import { Tabs } from "../../Components/AdminRequestSupportComponents/Tabs";
import HeaderDiv from "../../Components/HeaderDiv/HeaderDiv";
import SearchBoxesDiv from "../../Components/HeaderDiv/HeaderDivComponents/SearchBoxesDiv/SearchBoxesDiv";
import { ConvertDateValues } from "../../custom_hooks/ChangeDateValues";
import CloseShipMentTrack from "./CloseShipMent";
import useFetchTableData from "../../custom_hooks/useFetchTableData";
import { RiEdit2Fill ,RiCloseFill,} from "react-icons/ri";

const queryfunction = (fields) => {
  // console.log(fields, "fieldsfieldsfieldsfieldsfields");

  const query = gql`
  query GetAllTripTracks($isLive: Boolean) {
  getAllTripTracks(Is_Live: $isLive) {
  _id
        ${fields?.join(" ")}
      }
    }
  `;

  return query;
};
const queryForAllTracks = gql`
  query GetAllTripTracks($isLive: Boolean) {
  getAllTripTracks(Is_Live: $isLive) {
    _id
    Unique_Id
    Vehicle_No
    Loading_Area
    Loading_By
    Loading_City
    Loading_Date
    Loading_Landmark
    Loading_Name
    Loading_Pincode
    Loading_Town
    Loading_Scope
    Loading_State
    Loading_Time
    Unloading_Latitude
    Unloading_Longitude
    Unloading_Area
    Unloading_City
    Unloading_Name
    Unloading_Pincode
    Unloading_Town
    tripId
    Driver_Number
    From_Location
    From_Type
    To_Location
    To_Type
    Is_Live
    Current_Stage
    LP_Business_Name
    Expiry_Time
    Mobile_Number
    Is_Driver_Status
    Driver_ID
    createdAt
    updatedAt
  }
}
`

const MyShipmentTracking = () => {
  const [selectedCate, setSelectedCate] = useState({ isLive: true });
  const [formdata, setformdata] = useState<any>([]);
  const [showCloseModal, setShowCloseModal] = useState(false);
  const [selectedTab, setSelectedTab] = useState("Open")
  const [fetchAllLoad, { loading: queryLoading, error, data }] = useLazyQuery(
    queryfunction([]),
    {
      variables: selectedCate,
      fetchPolicy: "cache-and-network",
      onCompleted: () => {
        setIsLoading(false);
      },
      onError: () => {
        setIsLoading(false);
      },
      context: {
        headers: { "X-GraphQL-Server": "secondary" },
      },
    }
  );

  const Tab = useSelector((store: any) => store.SelectedTabData?.tab) || "Open";
  const [LoadId, setLoadId] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const dispatch = useDispatch();
  const Key = "My_Shipments";
  useFetchTableData(queryfunction, fetchAllLoad, setIsLoading, `MyShipmentTracking_${Tab}`);
  let statusTab = [{ name: "Open" }, { name: "Close" }];
  let handleLoadClosefuc = async (Loadid) => {
    setLoadId(Loadid);
    setShowCloseModal(true);
  };

  const Handle_Click_Edit = () => {
    const E_button = document.getElementById("edit_icon_button");
    E_button?.click()
  }
  useEffect(() => {
    if (data?.getAllTripTracks) {
      let updatedData = ConvertDateValues(data?.getAllTripTracks)?.map(el => {

        el.Close = (
          <div onClick={() => handleLoadClosefuc(el.tripId
          )}>
           <RiCloseFill width={"20px"} height={"20px"} color="red" />
          </div>
        )
        el.Edit = (
          <RiEdit2Fill width={"16px"} height={"16px"} onClick={() => Handle_Click_Edit()} />
        )
        return {
          Edit: el.Edit,
          ...el
        }
      })
      setformdata(updatedData)
    }
  }, [data])
  useEffect(() => {
    dispatch({ type: "TabData", payload: { tab: "Open" } });
  }, []);

  useEffect(() => {
    if (Tab === "Open") {
      setSelectedCate({ isLive: true });

      setSelectedTab("Open")
      // fetchAllLoad({
      //   variables: { isLive: true }
      // })
      dispatch({ type: "TabData", payload: { tab: "Open" } });

    } else if (Tab === "Close") {
      setSelectedCate({ isLive: false });
      // fetchAllLoad({
      //   variables: { isLive: false }
      // })
      setSelectedTab("Close")
      dispatch({ type: "TabData", payload: { tab: "Close" } });
    }
  }, [Tab]);



  return (
    <div className="LoadContainer">
      <div className="HeaderDiv">
        <div>
          <p className="pageTitle">My Shipment Trackings</p>
          <div className="hr1ForPageTitle"></div>
        </div>
        <SearchBoxesDiv />
      </div>
      <Tabs tabs={statusTab} />
      <HeaderDiv title={""} />
      {isLoading ? (
        <Loading />
      ) : !formdata?.length ? (
        <p className="DataNotAvailable">Data not Available</p>
      ) : (
        <>
          {queryLoading && <div className="loader-line-div" />}
          <LoadTable title={`MyShipmentTracking_${Tab}`} data={formdata} loading={isLoading} error={error} />
          {showCloseModal && (
            <CloseShipMentTrack show={showCloseModal} tripId={LoadId} setShowModal={() => setShowCloseModal(!showCloseModal)} fetchAllLoad={fetchAllLoad} />
          )}
        </>
      )}
    </div>
  );
};

export default MyShipmentTracking;
